/**
 * Shared helpers for the MerchCheckout page and its sub-components.
 * Kept in a tiny file so form fields and the order summary can be split out
 * of the massive MerchCheckout orchestrator without dragging duplicated
 * `fmt`/`Field`/`Row`/`US_STATES` copies into each new file.
 */

export const US_STATES = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA", "HI", "ID", "IL", "IN", "IA",
  "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
  "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT",
  "VA", "WA", "WV", "WI", "WY", "DC",
];

/** Format a currency amount. Uses Intl.NumberFormat with 2 decimals so line
 * items ($20.00), taxes ($0.75), and totals ($120.00) all render consistently. */
export function fmt(n, cur = "USD") {
  return new Intl.NumberFormat("en-US", { style: "currency", currency: cur || "USD" }).format(Number(n) || 0);
}

/** Small labeled input row used across the shipping-address form. */
export function Field({ label, value, onChange, type = "text", testid, required, className = "" }) {
  return (
    <label className={`block space-y-1 ${className}`}>
      <span className="text-[10px] uppercase tracking-[0.3em] font-bold text-white/60">
        {label}{required ? " *" : ""}
      </span>
      <input
        type={type}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        data-testid={testid}
        className="w-full bg-black border-2 border-white/20 text-white px-3 py-2 text-sm focus:outline-none focus:border-[#B32027]"
      />
    </label>
  );
}

/** One "label — value" row inside the order-summary card. */
export function Row({ label, value, testid }) {
  return (
    <div className="flex justify-between text-white/70">
      <span>{label}</span>
      <span data-testid={testid} className="text-white">{value}</span>
    </div>
  );
}
